import React from "react";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import {
  GETTING_STARTED,
  STREAM_SCAN,
  HOME,
  CUSTOM,
  THANKYOU_SCREEN,
  SETUP_FLOW,
  FACE_SCAN,
  MEASUREMENT_STATUS,
  MUSE_STATUS,
} from "../vars";
import App from "../App";
import Home from "../pages/home/Home";
import GettingStarted from "../pages/gettingStarted/GettingStarted";
import Custom from "../pages/custom/Custom";
import ScreenWrapper from "../wrapper/ScreenWrapper";
import ThankYouScreen from "../pages/thankyouScreen/thankyouScreen";
import SetupFlow from "../pages/setupFlow/SetupFlow";
import UserAttributesWrapper from "../wrapper/UserAttributesWrapper";
import MuseGenerationStatus from "../components/MuseGenerationStatus";
import AuthCallback from "../pages/authCallback/AuthCallback";
import QRCode from "../pages/QRcode/QRCode";
import BodyScanPage from "../pages/bodyScan/BodyScanPage";
import FaceScanPage from "../pages/faceScan/FaceScanPage";
import MeasurementStatus from "../components/MeasurementStatus";

function ProjectRoutes() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <App />,
      children: [
        {
          path: HOME,
          element: (
            <UserAttributesWrapper>
            <ScreenWrapper>
              <Home />
            </ScreenWrapper>
            </UserAttributesWrapper>
          )
        },
        {
          path: GETTING_STARTED,
          element: <GettingStarted />,
        },
        {
          path: SETUP_FLOW,
          element: <SetupFlow />,
        },
        {
          path: FACE_SCAN,
          element: <FaceScanPage />,
        },
       
        {
          path: "*",
          element: <Navigate to={HOME} replace />,
        },
        {
          path: "qrcode",
          element: <QRCode />,
        },
        {
          path: MEASUREMENT_STATUS,
          element: <MeasurementStatus />,
        },
        {
          path: STREAM_SCAN,
          element: <BodyScanPage />,
        },
        {
          path: CUSTOM,
          element: <Custom />,
        },
        {
          path: THANKYOU_SCREEN,
          element: <ThankYouScreen />,
        },
        {
          path: MUSE_STATUS,
          element: <MuseGenerationStatus />,
        },
        {
          path: "/auth/callback",
          element: <AuthCallback />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default ProjectRoutes;
